import { render, staticRenderFns } from "./SIG.vue?vue&type=template&id=d8229612&scoped=true&lang=pug"
import script from "./SIG.vue?vue&type=script&lang=js"
export * from "./SIG.vue?vue&type=script&lang=js"
import style0 from "./SIG.vue?vue&type=style&index=0&id=d8229612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8229612",
  null
  
)

export default component.exports